import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { MetrikTypeHoldingService } from '../../../settings/metrik-type-holding/metrik-type-holding.service';
import { LeaseTypeService } from '../../../settings/lease-type/lease-type.service';
import { SupplierService } from '../../supplier/supplier.service';
import { EstablishmentService } from '../../establishment/establishment.service';

export const BUILDING_FILTER_SCHEMA: FilterSchema = {
  establishments: { type: 'entity[]', resolve: { service: EstablishmentService, displayProperty: 'label' } },
  // Ville principale calculée côté back (/main-cities) : la chip est la valeur elle-même
  mainCity: { type: 'value[]', valueField: 'mainCity' },
  label: { type: 'text' },
  detentionType: { type: 'entity[]', resolve: { service: MetrikTypeHoldingService, displayProperty: 'label' } },
  supplier: { type: 'entity[]', resolve: { service: SupplierService, displayProperty: 'label' } },
  leaseType: { type: 'entity[]', resolve: { service: LeaseTypeService, displayProperty: 'label' } },
};
